"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Firestore = void 0;
const cheat_codes_firestore_service_1 = require("./cheat-codes-firestore.service");
const constants_firestore_service_1 = require("./constants-firestore.service");
const versions_firestore_service_1 = require("./versions-firestore.service");
const games_firestore_service_1 = require("./games-firestore.service");
class Firestore {
    constructor(rawFirestore) {
        this.cheatCodes = new cheat_codes_firestore_service_1.CheatCodesFirestore(rawFirestore);
        this.constants = new constants_firestore_service_1.ConstantsFirestore(rawFirestore);
        this.versions = new versions_firestore_service_1.VersionsFirestore(rawFirestore);
        this.games = new games_firestore_service_1.GamesFirestore(rawFirestore);
    }
}
exports.Firestore = Firestore;
